module.exports = __webpack_public_path__ + "img/п.4.b9439a00.png";